import { Box } from "@mui/material";
import authPrez from "../../../image/authPrez.png";

export const RightBlockLogin = () => {

  return (
    <Box className="left_block" sx={{ height: "100%" }}>
      <Box
        component="img"
        src={authPrez}
        sx={{ width: "100%", objectFit: "cover", objectPosition: "0 0", height: "100%" }}
        alt="ВДПО"
      />
    </Box>
  );
};
